import { useDispatch } from 'react-redux';
import { useMutation } from '@apollo/client';
import { REMOVE_CART_TRIAL } from '../../../apollo';
import { cartSlice } from '../../../redux';

type RemoveCartTrialEffectReturn = {
  removeCartTrial: (id: number) => void;
  loading: boolean;
  success: boolean;
  error: string | undefined;
};

export const useRemoveCartTrialEffect = (
  callback?: () => void
): RemoveCartTrialEffectReturn => {
  const dispatch = useDispatch();

  const [doRemoveCartTrial, { loading, called, error }] = useMutation(
    REMOVE_CART_TRIAL,
    {
      onCompleted: (data) => {
        dispatch(cartSlice.actions.updateCart(data.removeCartTrial));
        if (callback) {
          callback();
        }
      },
    }
  );

  const removeCartTrial = (id: number): void => {
    const variables = { id };

    doRemoveCartTrial({ variables }).then();
  };

  const success = !loading && called && !error;

  return {
    removeCartTrial,
    loading,
    success,
    error: error?.message,
  };
};
